import { IconButton } from '@clickcease/cc-client-components-lib'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Cross2Icon } from '@radix-ui/react-icons'
import React, { ReactNode } from 'react'

import { StyledOverlay, StyledContent, StyledCloseButton } from './Modal.styled'

interface ModalProps {
  children: ReactNode
  isOpen: boolean
  onOpenChange: (a: boolean) => void
  borderRadius?: '25px' | '12px' | '4px'
  closeButtonPosition?: { top: string; right: string }
  onCloseModalIcon?: () => void
  disableAutoFocus?: boolean
  id?: string
}

export const Dialog = ({
  id,
  children,
  isOpen,
  onOpenChange,
  borderRadius,
  closeButtonPosition,
  onCloseModalIcon,
  disableAutoFocus,
}: ModalProps) => {
  return (
    <DialogPrimitive.Root modal open={isOpen} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <StyledOverlay />
        <StyledContent
          id={id}
          borderRadius={borderRadius}
          onOpenAutoFocus={(e) => {
            disableAutoFocus ? e.preventDefault() : null
          }}
        >
          {children}
          <StyledCloseButton asChild>
            <IconButton
              onClick={onCloseModalIcon}
              aria-label="Close"
              css={{ top: '35px', right: '30px', ...closeButtonPosition }}
            >
              <Cross2Icon width="15px" height="15px" />
            </IconButton>
          </StyledCloseButton>
        </StyledContent>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
